import { tabAccessControl } from "../../../_helpers/access-control";

let disableCount = true;
let disableReview = true;
let queryId = undefined;

function StockTakeTabs(baseView) {
  if (baseView) {
    if (baseView.mode === "create") {
      disableCount = disableReview = true;
    } else {
      if (baseView.id) queryId = baseView.id;

      disableReview = false;
      if (baseView.isEditable != undefined) disableCount = !baseView.isEditable;
      else disableCount = false;
    }
  }
  return [
    {
      text: "Prepare",
      path: queryId
        ? `/stock-take-prepare/review/` + queryId
        : `/stock-take-prepare/create`,
      applicationFeatureCode: "StocktakeManagement",
      ignoreRouteChange: true,
    },
    {
      text: "Count",
      path: `/stock-take-count/edit/` + queryId,
      applicationFeatureCode: "StocktakeManagement",
      disabled: disableCount,
      ignoreRouteChange: true,
    },
    {
      text: "Review",
      path: `/stock-take-review/review/` + queryId,
      applicationFeatureCode: "StocktakeManagement",
      disabled: disableReview,
      ignoreRouteChange: true,
    },
  ];
}

function GetIndexByTabName(tabName) {
  return tabAccessControl(StockTakeTabs()).findIndex((x) => x.text == tabName);
}

function StockTakeTabsVisibility(baseView) {
  if (baseView.mode === "create") {
    disableCount = disableReview = true;
  } else {
    if (baseView.id) queryId = baseView.id;
    disableCount = disableReview = false;
  }
}

export { StockTakeTabs, GetIndexByTabName, StockTakeTabsVisibility };
